import React, { useState, useEffect } from "react";

import "./App.css";

import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Skill from "./Components/Skills/Skill";
import Project from "./Components/Projects/Project";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Experience from "./Components/Experience/Experience";

function App() {
    const [darkMode, setDarkMode] = useState(getInitialDarkMode());

    function getInitialDarkMode() {
        return (
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        );
    }

    useEffect(() => {
        const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");

        const handleChange = (e) => {
            setDarkMode(e.matches);
        };

        darkModeQuery.addEventListener("change", handleChange);

        return () => {
            darkModeQuery.removeEventListener("change", handleChange);
        };
    }, []);

    useEffect(() => {
        document.body.className = darkMode ? "dark-theme" : "light-theme";
    }, [darkMode]);

    function toggleDarkMode() {
        setDarkMode((prev) => !prev);
    }

    return (
        <div className={`app ${darkMode ? "dark" : ""}`}>
            <div className="background-orb orb-1"></div>
            <div className="background-orb orb-2"></div>
            <div className="background-grid"></div>

            <Navbar darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

            <main>
                <Home darkMode={darkMode} />

                <About darkMode={darkMode} />

                <Skill darkMode={darkMode} />

                <Experience darkMode={darkMode} />

                <Project darkMode={darkMode} />

                <Contact darkMode={darkMode} />
            </main>

            <Footer darkMode={darkMode} />
        </div>
    );
}

export default App;
